import {
  createContext,
  useContext,
  useEffect,
  useState,
  type FC,
  type ReactNode,
} from 'react';

export type RequestFormProduct = {
  productName: string;
  brochureName?: string;
  brochureUrl?: string;
};

type RequestFormContextValue = {
  product: RequestFormProduct | null;
  setProduct: (product: RequestFormProduct | null) => void;
};

const RequestFormContext = createContext<RequestFormContextValue | null>(null);

export const RequestFormProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [product, setProduct] = useState<RequestFormProduct | null>(null);

  return (
    <RequestFormContext.Provider value={{ product, setProduct }}>
      {children}
    </RequestFormContext.Provider>
  );
};

export function useRequestFormProduct(): RequestFormProduct | null {
  return useContext(RequestFormContext)?.product ?? null;
}

export function useRegisterRequestFormProduct(
  productName?: string | null,
  brochure?: { name?: string | null; url?: string | null } | null,
): void {
  const setProduct = useContext(RequestFormContext)?.setProduct;
  const name = productName?.trim() || '';
  const brochureName = brochure?.name?.trim() || undefined;
  const brochureUrl = brochure?.url?.trim() || undefined;

  useEffect(() => {
    if (!setProduct || !name) return undefined;

    setProduct({ productName: name, brochureName, brochureUrl });
    return () => {
      setProduct(null);
    };
  }, [setProduct, name, brochureName, brochureUrl]);
}
